import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export default function NoteSelect({ className = "", value, onChange, placeholder = "Select", options = [] }) {
  const triggerRef = useRef(null);
  const windowRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [style, setStyle] = useState(null);

  const current = options.find(o => String(o.value) === String(value));

  useEffect(() => {
    if (!open ||!triggerRef.current) return;
    const update = () => {
      const rect = triggerRef.current.getBoundingClientRect();
      const width = Math.min(Math.max(rect.width, 180), window.innerWidth - 24);
      const left = Math.max(12, Math.min(rect.left, window.innerWidth - width - 12));
      const below = window.innerHeight - rect.bottom - 12;
      const above = rect.top - 12;
      const showAbove = below < 200 && above > below;
      const maxHeight = Math.max(150, Math.min(260, showAbove? above : below));
      setStyle({ position: "fixed", left, top: showAbove? rect.top - maxHeight - 6 : rect.bottom + 6, width, maxHeight, zIndex: 10060 });
    };
    update();
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, true);
    return () => { window.removeEventListener("resize", update); window.removeEventListener("scroll", update, true); };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const close = (e) => {
      if (triggerRef.current &&!triggerRef.current.contains(e.target) && windowRef.current &&!windowRef.current.contains(e.target)) setOpen(false);
    };
    const esc = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", close); document.removeEventListener("keydown", esc); };
  }, [open]);

  const win = open && style? (
    <div className="note-select-window" style={style} ref={windowRef}>
      {options.map(o => {
        const sel = String(o.value) === String(current?.value);
        return (
          <button type="button" key={o.value} className={`note-select-option${sel? " selected" : ""}`} onClick={() => { onChange(o.value); setOpen(false); }}>
            <span className="note-tick">{sel? "✓" : "·"}</span><span className="note-opt-label">{o.label}</span>
          </button>
        );
      })}
    </div>
  ) : null;

  return (
    <>
      <div className="note-select-wrap" ref={triggerRef}>
        <button type="button" className={`note-field note-select-trigger ${current? "has-value" : ""} ${className}`} onClick={() => setOpen(o =>!o)}>
          <span>{current? current.label : placeholder}</span>
          <span className="note-chevron">⌄</span>
        </button>
      </div>
      {typeof document!== "undefined" && createPortal(win, document.body)}
    </>
  );
}